<template>
    <app-layout title="Add Customer">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Add Customer</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" class="h-7 leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button class="h-7 leading-none" :disabled="form.processing" :href="route('customers.index')">
                        {{ form.isDirty ? 'Cancel' : 'Close' }}
                    </jet-tertiary-button>
                </template>
            </page-header>

            <div class="px-8 xl:flex">
                <customer-form
                    :form="form"
                    :sales-reps="salesReps"
                    :delivery-options="deliveryOptions"
                    :type-options="typeOptions"
                    :route-options="routeOptions"
                    :pricing-options="pricingOptions"
                    :payment-terms-options="paymentTermsOptions"
                    :payment-method-options="paymentMethodOptions"
                />

                <customer-pricing-form
                    :form="form"
                    :products="products"
                />
            </div>
        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import CustomerForm from '@/Pages/Customer/Partials/CustomerForm';
import CustomerPricingForm from '@/Pages/Customer/Partials/CustomerPricingForm';

import '@vueform/multiselect/themes/default.css';
import '@vueform/toggle/themes/default.css';

export default {
    setup() {
        const form = useForm({
            id: null,
            enabled: true,
            sales_rep_id: null,
            pricing_level_id: null,
            tax_exempt: false,
            show_picksheet_pricing: false,
            type: null,
            name: null,
            address_1: null,
            address_2: null,
            city: null,
            postal_code: null,
            province: 'Ontario',
            phone: null,
            cell: null,
            fax: null,
            email: null,
            ap_email: null,
            contact_name: null,
            default_shipping_method: 'delivery',
            route: null,
            delivery_days: [],
            delivery_duration: null,
            delivery_order_minimum: null,
            delivery_fee: null,
            delivery_window_start: null,
            delivery_window_end: null,
            auto_apply_credit: false,
            credit_balance: null,
            internal_notes: null,
            order_notes: null,
            load_notes: null,
            payment_terms: null,
            payment_method: null,
            pricing: [],
        })

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetTertiaryButton,
        CustomerForm,
        CustomerPricingForm,
    },

    props: [
        'salesReps', 
        'pricingOptions', 
        'typeOptions', 
        'routeOptions', 
        'deliveryOptions', 
        'products',
        'paymentTermsOptions', 
        'paymentMethodOptions'
    ],

    data() {
        return {
            showDeleteModal: false,
        }
    },

    methods: {
        submit() {
            this.form.post(route('customers.store'));
        },
    },
}
</script>

<style scoped>

</style>
